import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const GoToStationButton = (props) => {
  const navigate = useNavigate();

  const navigation = (theRouteUrl) => {
    const navigateUrl = "/stations/" + theRouteUrl;
    navigate(navigateUrl);
  };

  return (
    <button
      className="btn btn-dark btn-sm"
      onClick={() => navigation(props.theRouteUrl)}
    >
      اطلاعات ایستگاه
    </button>
  );
};

export default GoToStationButton;
